module.exports = __webpack_public_path__ + "static/media/PlusBorderGreen.51c77558.svg";